import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-input-general-text',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, TranslateModule],
  templateUrl: './input-general-text.component.html',
})
export class InputGeneralTextComponent {
  @Input() formControlGeneral: FormControl | null = new FormControl();
  @Input() placeholder = '';
  @Input() label = '';

  isRequired(control: AbstractControl | null): boolean {
    return !!control?.hasValidator?.(Validators.required);
  }
}
